<template>
  <div id="app">

    <div
      id="appCapsule"
      :class="{
        'qvp-page':
          this.$route.name === 'QVP Exam' ||
          this.$route.name === 'QVP Main' ||
          this.$route.name === 'QVP Kids Final Result' ||
          this.$route.name === 'QHLS Exam',
        'wisdom-exam-shell': this.$route.name === 'Wisdom Exam' || this.$route.name === 'Wisdom Exam Winners',
      }"
    >
      <app-header
        v-if="
          this.$route.name != 'OTP' &&
          this.$route.name != 'QVP Exam' &&
          this.$route.name != 'QVP Main' &&
          this.$route.name != 'QVP Kids Final Result' &&
          this.$route.name != 'QHLS Exam' &&
          this.$route.name != 'Wisdom Exam' &&
          this.$route.name != 'Wisdom Exam Winners'
        "
        :page_header="page_header"
        :minutes="minutes"
        :seconds="seconds"
        :header_actions="header_actions"
        @header-action="onHeaderActionGlobal($event)"
      >
      </app-header>
      <router-view :key="$route.path" />
    </div>

    <!-- ── FOOTER WRAPPER with update banner sliding from behind ── -->
    <div class="footer-wrapper" v-if="this.$route.name != 'EPR' && this.$route.name != 'OTP' && this.$route.name != 'Login' && this.$route.name != 'Welcome' && this.$route.name != 'Register' && this.$route.name != 'UserLogin' && this.$route.name != 'Conference Registration' && this.$route.name != 'PER' && this.$route.name != 'EVBD' && this.$route.name != 'Donation' && this.$route.name != 'QVP Exam' && this.$route.name != 'QVP Main' && this.$route.name != 'QVP Kids Final Result' && this.$route.name != 'QHLS Exam' && this.$route.name != 'Wisdom Exam' && this.$route.name != 'Wisdom Exam Winners'">
      <transition name="update-banner-slide">
        <div
          v-if="updateAvailable"
          class="update-banner"
          @click="applyUpdate"
        >
          <span class="update-banner-icon">
            <ion-icon name="refresh-outline"></ion-icon>
          </span>
          <span class="update-banner-text">New update available — tap to refresh</span>
          <span class="update-banner-arrow">
            <ion-icon name="chevron-forward-outline"></ion-icon>
          </span>
        </div>
      </transition>
      <app-footer-menu></app-footer-menu>
    </div>
    <div class="appFooter" v-else-if="this.$route.name != 'QVP Exam' && this.$route.name != 'QVP Main' && this.$route.name != 'QVP Kids Final Result' && this.$route.name != 'QHLS Exam' && this.$route.name != 'Wisdom Exam' && this.$route.name != 'Wisdom Exam Winners'">
      <div class="footer-title">
        Copyright © Wisdom It Wing 2024. All Rights Reserved.
      </div>
      Wisdom Islamic Organizations
    </div>
    <!-- <div class="appFooter">
      <div class="footer-title">
        Copyright © Finapp 2021. All Rights Reserved.
      </div>
      Bootstrap 5 based mobile template.
    </div> -->
    <app-side-menu></app-side-menu>
  </div>
</template>

<script type="module">
import AppHeader from './views/layouts/AppHeader.vue';
import AppFooterMenu from './views/layouts/AppFooterMenu.vue';
import AppSideMenu from './views/layouts/AppSideMenu.vue';
import { updateEventBus } from './registerServiceWorker';

export default {
  components: {
    AppHeader,
    AppFooterMenu,
    AppSideMenu
  },
  data() {
    return {
      'page_header': null,
      'minutes': null,
      'seconds': null,
      'header_actions': [],   // [{key, icon, label, badge}] — set per-page
      buildVersionCheckInterval: null,
      updateAvailable: false,   // shows the update notification banner
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    showAdminBoard() {
      if (this.currentUser && this.currentUser['roles']) {
        return this.currentUser['roles'].includes('ROLE_ADMIN');
      }

      return false;
    },
    showModeratorBoard() {
      if (this.currentUser && this.currentUser['roles']) {
        return this.currentUser['roles'].includes('ROLE_MODERATOR');
      }

      return false;
    }
  },
  mounted() {
    this.page_header = null;
    this.minutes = null;
    this.seconds = null;
    updateEventBus.on(() => {
      this.notifyUpdate();
    });
    this.startVersionCheck();
  },
  beforeUnmount() {
    if (this.buildVersionCheckInterval) {
      clearInterval(this.buildVersionCheckInterval);
    }
    if (this._versionCheckVisibility) {
      document.removeEventListener('visibilitychange', this._versionCheckVisibility);
    }
  },
  methods: {
    // Called when an update is detected — show banner instead of auto-reloading
    notifyUpdate() {
      this.updateAvailable = true;
    },
    // User tapped the banner — now do the actual reload
    applyUpdate() {
      window.location.reload();
    },
    checkForAppUpdate() {
      const currentVersion = String(process.env.BUILD_VERSION || '');
      if (!currentVersion) return;
      const url = `${window.location.origin}/version.json?_=${Date.now()}`;
      fetch(url, { cache: 'no-store', credentials: 'omit' })
        .then((r) => { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then((data) => {
          if (data && data.version != null && String(data.version) !== currentVersion) {
            this.notifyUpdate();
          }
        })
        .catch(() => {});
    },
    startVersionCheck() {
      // Check soon after load, then every 2 minutes, and whenever user returns to the tab
      setTimeout(() => this.checkForAppUpdate(), 15000);
      this.buildVersionCheckInterval = setInterval(() => this.checkForAppUpdate(), 2 * 60 * 1000);
      this._versionCheckVisibility = () => {
        if (document.visibilityState === 'visible') this.checkForAppUpdate();
      };
      document.addEventListener('visibilitychange', this._versionCheckVisibility);
    },
    onHeaderActionGlobal(key) {
      // Fallback for pages using the emit pattern instead of onClick callbacks
      // Per-page handlers use action.onClick directly (Vue 3 compatible)
      console.warn('Header action received without onClick handler:', key);
    },
    updateParent(variable) {
      this.page_header = variable;
    },
    updateHeaderActions(actions) {
      this.header_actions = actions || [];
    },
    updateMinutes(variable) {
      this.minutes = variable;
    },
    updateSeconds(variable) {
      this.seconds = variable;
    },
    logOut() {
      this.$store.dispatch('auth/logout');
      location.replace('/');
    }
  },
};
</script>

<style scoped>
/* ── UPDATE NOTIFICATION BANNER ─────────────────────────────────────────── */
.footer-wrapper {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 9999;
}
.update-banner {
  position: absolute;
  bottom: 100%;
  left: 0;
  right: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  gap: 10px;
  background: linear-gradient(90deg, #1a418c 0%, #2355b3 100%);
  color: #fff;
  padding: 10px 16px;
  cursor: pointer;
  box-shadow: 0 -2px 12px rgba(0,0,0,0.25);
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}
.update-banner:active {
  opacity: 0.88;
}
.update-banner-icon {
  font-size: 18px;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  animation: spin-once 0.6s ease-in-out;
}
.update-banner-text {
  flex: 1;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.1px;
}
.update-banner-arrow {
  font-size: 16px;
  display: flex;
  align-items: center;
  opacity: 0.8;
}

/* Slide-up entry / slide-down exit */
.update-banner-slide-enter-active {
  transition: transform 0.3s ease, opacity 0.3s ease;
}
.update-banner-slide-leave-active {
  transition: transform 0.2s ease, opacity 0.2s ease;
}
.update-banner-slide-enter-from,
.update-banner-slide-leave-to {
  transform: translateY(100%);
  opacity: 0;
}

@keyframes spin-once {
  0%   { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>

<style>
/* Bootstrap's own .modal/.modal-backdrop default to z-index 1050/1040 — well below
   .footer-wrapper above (z-index:9999, position:fixed). Every bottom-sheet/alert dialog in the
   app uses the standard `class="modal fade action-sheet"` pattern, so on iOS Safari in
   particular (whose position:fixed stacking-context handling differs from Android/desktop) that
   left dialogs rendering behind the bottom nav instead of above it. Global, unscoped override —
   Bootstrap's own CSS loads first, so !important is needed to win regardless of source order. */
.modal-backdrop {
  z-index: 10000 !important;
}
.modal {
  z-index: 10010 !important;
}
</style>
